import axios from 'axios';
import {
  all_information,
  GetBackendUrlForGlobalFunctions, GetErpTypeFromConfig,
  loadingShow,
} from '../../App';
import {convertToDateInput, DependencyInfo, InlineEditOrderType} from '../Types/types';
import Message from '../Message/Message';
import { EditOperations } from '../../services/Operations/OperationServices';
import moment from 'moment';
export function adjustDates(operationData: any[], offset: number) {
  return operationData.map(({ plannedStartDate, plannedEndDate, planned_end_date,planned_start_date,...rest }) => ({
    ...rest,
    scheduled_start_date: new Date(new Date(rest.scheduled_start_date).getTime() + offset),
    scheduled_end_date: new Date(new Date(rest.scheduled_end_date).getTime() + offset),
  }));

}
export const EXPORT_ROW_COLORS: Record<'order' | 'operation' | 'asset', string> = {
  order: '#C9E3EB',
  operation: '#FFFFFF',
  asset: '#8AB4CF',
};
export function getAdjustedDatas(datas: any[], type: string | undefined, offsetDiff: number, serverOffsetMillis : number): any[] {
  console.log("type: ",type)
  if (!type) {
    return adjustDates(datas, -serverOffsetMillis);
  }
  //
  // if (type === 'edit-button') {
  //     console.log("this.serverOffsetMillis: " + this.serverOffsetMillis/(6000 *60*10));
  //     const differenceOffsetMillis = this.serverOffsetMillis - this.localOffsetMillis;
  //     console.log("this.differenceOffsetMillis: " + differenceOffsetMillis/(6000 *60*10));
  //     console.log("this.localOffsetMillis: " + this.localOffsetMillis/(6000 *60*10));
  //     console.log("this.offsetDiff: " + offsetDiff/(6000 *60*10));
  //
  //     return this.adjustDates(datas, differenceOffsetMillis);
  // }
  // if (type === 'drag') {
  //     return this.adjustDates(datas,  0);
  // }
  console.log("offsetDiff 44444: ",offsetDiff/(6000*600))

  return adjustDates(datas, offsetDiff);
}
export function isInlineEditOrderDataEqual(
  object1: InlineEditOrderType,
  object2: InlineEditOrderType
) {
  let res: boolean = true;
  object1.priority_code !== object2.priority_code ? (res = false) : (res = res);
  object1.priority_id !== object2.priority_id ? (res = false) : (res = res);
  object1.asset_description !== object2.asset_description
    ? (res = false)
    : (res = res);
  object1.department_code !== object2.department_code
    ? (res = false)
    : (res = res);
  object1.department_id !== object2.department_id ? (res = false) : (res = res);
  object1.status_code !== object2.status_code ? (res = false) : (res = res);
  object1.status_id !== object2.status_id ? (res = false) : (res = res);
  object1.type_code !== object2.type_code ? (res = false) : (res = res);
  object1.type_id !== object2.type_id ? (res = false) : (res = res);
  object1.site_details_1 !== object2.site_details_1
    ? (res = false)
    : (res = res);
  object1.wo_labour_cost !== object2.wo_labour_cost
    ? (res = false)
    : (res = res);
  object1.wo_material_cost !== object2.wo_material_cost
    ? (res = false)
    : (res = res);
  object1.wo_other_cost !== object2.wo_other_cost ? (res = false) : (res = res);
  return res;
}

export const getLocalUtcOffSetValue = (): number => {
  const localUTCString = localStorage.getItem('tzDrawer');
  if (
    localUTCString != undefined &&
    localUTCString != '' &&
    localUTCString !== null
  ) {
    var index = localUTCString!.indexOf('+');
    if (index === -1) {
      index = localUTCString!.indexOf('-');
    }
    if (index !== -1) {
      var substringAfterePlusMinus = localUTCString!.substring(index);
      return parseInt(substringAfterePlusMinus) * 60;
    } else {
      return 0;
    }
  } else {
    return 0;
  }
};

export const getFilteredOrder = async (
  current_query: string | undefined,
  applyTheRule: any,
  section: string
) => {
  if (current_query !== undefined && current_query !== '') {
    let jsonString_current_query: string = current_query;
    if (section === 'planning-console-section') {
      let query = current_query.split('?');
      //jsonString_current_query = current_query.slice(0, -1);
      //jsonString_current_query = query[0];
      let plan_id = localStorage.getItem('cs_plan_dd_value');

      jsonString_current_query = `{"f":"plan_id","c":"=","t":"where","v":"${plan_id}"}`;
    }
    let jsonObject_current_query = JSON.parse(jsonString_current_query);
    if (jsonObject_current_query.f === 'plan_id') {
      jsonObject_current_query.f = 'ID';
    }
    jsonObject_current_query.t = 'andWhere';
    let init_query: string = JSON.stringify(jsonObject_current_query) + '?';
    let planner_query = await applyTheRule('uw_order', 'Cloud Planner');
    current_query = planner_query + init_query;
    let theUrl =
      GetBackendUrlForGlobalFunctions() +
      `order` +
      `/${0}?where=1$500$` +
      current_query;
    let theResult = await axios.get(theUrl);
    if (Array.isArray(theResult.data)) {
      theResult.data = theResult.data.map((item: any) => {
        // item.order_code varsa ve bir string ise trim uygulayın
        return { ...item, order_code: item?.order_code?.trim() };
      });
    }
    return theResult;
  }
};
export const stringToArray = (str: string): number[] => {
  let temp = [];
  temp = str.split(',');
  temp = temp.map((el) => parseInt(el));
  return temp;
};
export const extractNumbers = (text: string): string => {
  const regex = /\d+/g;
  const numbers = text.match(regex);
  return numbers ? numbers.join(',') : '';
};

export const extractStringValue = (jsonString: string): string => {
  const obj = JSON.parse(jsonString);
  const valuesString = JSON.stringify(obj);
  const regex = /"([^"]*)"/g;
  let match;
  const results: string[] = [];

  while ((match = regex.exec(valuesString)) !== null) {
    if (match[1] !== 'value') {
      results.push(match[1]);
    }
  }
  return results.length > 0 ? results[0] : '';
};

export const extractCharacters = (str: any): string[] => {
  if (str != null) {
    var parsed = JSON.parse(str);
    var characters = parsed.value.map(function (char: any) {
      return char.toString();
    });
    return characters;
  }
  return [];
};
export const convertToDate = (input: convertToDateInput) => {
  const { startDate, endDate, value } = input;
  // var value= value.map((dateString) => new Date(dateString)),
  const output = [new Date(startDate), new Date(endDate)];
  return output;
};

export const removeParentheses = (expression: string): string => {
  return expression.replace(/[()]/g, '');
};

export const SavePointEdit = async (dataInput: any): Promise<void> => {
  var updatedList: Object[] = [];
  if (!Array.isArray(dataInput)) {
    dataInput = [dataInput];
  }
  dataInput.map((data: any) => {
    if (data.label) {
      delete data.label;
      delete data.tradeDescription;
    }
    let duration = moment(new Date(data.scheduled_end_date)).diff(
      new Date(data.scheduled_start_date),
      'hours'
    );
    let the_end_date = data.scheduled_end_date;
    if (data.estHours !== null && data.required !== null) {
      var theDurationResult = Number(data.estHours) / Number(data.required);
      the_end_date = moment(new Date(data.scheduled_start_date))
        .add(theDurationResult, 'h')
        .toDate();
      duration = theDurationResult;
    }
    const first_obj: any = {
      ...data,
      organizationId: data.organizationId.toString(),
      createdBy: all_information.user_id,
      // required: parseFloat(data.required).toFixed(2),
      // estHours: parseFloat(data.estHours).toFixed(2),
      //i added toString()
      required: data.required?.toString(),
      estHours: data.estHours?.toString(),
      operationId: Number(data.operationId),
      qtyAssigned: '',
      duration: duration?.toString(),
      scheduled_end_date: new Date(the_end_date),
    };
    delete first_obj.materialStatus;
    updatedList.push(first_obj);
  });
  // if (first_obj.pm_id) {
  //       first_obj.operationSequence = getSecondNumber(
  //     first_obj.operationSequence
  //   );
  // } else {
  //   first_obj.operationSequence = data.operationSequence;
  // }

  //   if (first_obj.pm_id) {
  //   if (first_obj.operationSequence.includes(first_obj.pm_id)) {
  //       first_obj.operationSequence = getSecondNumber(
  //     first_obj.operationSequence
  //   );
  //   }
  //   else {
  //     first_obj.pm_id = null;
  //     first_obj.operationSequence = data.operationSequence;
  //   }

  // } else {
  //   first_obj.operationSequence = data.operationSequence;
  // }
  const ERP_TYPE = GetErpTypeFromConfig();
  let allowCommit = ERP_TYPE == 'MEX' ? true: false;
  await EditOperations(updatedList, allowCommit)
    .then(() => {
      //Message.success('Success');
      loadingShow(false);
    })
    .catch((err: any) => {
      if (err.response) {
        Message.error(
          err.response.data +
            '\n' +
            err.response.status +
            '\n' +
            err.response.headers
        );
      } else if (err.request) {
        Message.error(err.request);
      } else {
        Message.error('Error: ' + err.message);
      }
      loadingShow(false);
    });
};

export function parseDependencyCode(dependencyCode: string): DependencyInfo | null {
  const match = dependencyCode.match(/^(\d+)\s+(FS|SS|FF|SF)/);

  if (!match) return null;

  const [, operationId, dependencyType] = match;

  return {
    operationId,
    dependencyType: dependencyType as DependencyInfo['dependencyType']
  };
}


export function groupTasksByDate(tasks: any[]): Record<string, any[]> {
  const grouped: Record<string, any[]> = {};

  for (const task of tasks) {
    const rawStart = task.StartDate ?? task.scheduled_start_date;
    const startHour = rawStart ? new Date(rawStart).getHours() : NaN;

    if (task.hasChildRecords === false) {
      const dateKey = formatDate(task.StartDate);
      if (!grouped[dateKey]) grouped[dateKey] = [];
      task.orderCode = task.taskData.orderCode;
      task.section = task.taskData.section;
      task.pm_schedule_id = task.pm_schedule_id;
      task.estHours = task.taskData.estHours;
      task.type_code = task.taskData.type_code;
      task.reason = task.taskData.reason;
      task.startHour = startHour;
      grouped[dateKey].push(task);
    }
    if (task.hasChildRecords === undefined) {
      const dateKey = task.StartDate !== undefined ? formatDate(task.StartDate) : task.scheduled_start_date;
      if (!grouped[dateKey]) grouped[dateKey] = [];
      task.startHour = startHour;
      grouped[dateKey].push(task);
    }
  }

  return grouped;
}
function formatDate(date: string | Date): string {
  const d = new Date(date);
  return d.toLocaleDateString('en-GB', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
}



export function transformToMultiTableFormat(groupedData: Record<string, any[]>): any[] {
  const result: any[] = [];
  for (const date in groupedData) {
    const tasks = groupedData[date];

    result.push({
      WorkOrderDescription: `### ${date.toUpperCase()} ###`,
      isHeader: true,
    });

    for (const task of tasks) {
      result.push({
        ...task,
        WorkOrderDescription: '',
        StartDate: task.StartDate !== undefined ? formatExcelDateTime(task.StartDate) : formatExcelDateTime(task.scheduled_start_date),
        EndDate: task.StartDate !== undefined ? formatExcelDateTime(task.EndDate) : formatExcelDateTime(task.scheduled_end_date),
      });
    }
    // const totalHours = tasks.reduce((sum, task) => {
    //   const estHours = Number(task.estHours);
    //   const required = Number(task.required);
    //   if (isNaN(estHours) || isNaN(required) || required === 0) {
    //     return sum;
    //   }
    //   return sum + estHours / required;
    // }, 0);

    const totalHours = tasks.reduce((sum, task) => {
      const estHours = Number(task.estHours);
      if (isNaN(estHours)) return sum;
      return sum + estHours;
    }, 0);

    result.push({
      WorkOrderDescription: `TOTAL HOURS FOR ${date.toUpperCase()}: ${totalHours}`,
      isFooter: true,
    });
    result.push({});
    result.push({});
  }

  return result;
}

function hexToRgb(hex: string): { r: number; g: number; b: number } | null {
  const clean = hex.replace('#', '');
  if (clean.length !== 6) return null;
  const num = parseInt(clean, 16);
  return { r: (num >> 16) & 255, g: (num >> 8) & 255, b: num & 255 };
}

export function applyOpacity(hex: string, opacity: number, backgroundHex: string): string {
  const fg = hexToRgb(hex);
  const bg = hexToRgb(backgroundHex);
  if (!fg || !bg) return hex;
  const blend = (f: number, b: number) => Math.round(f * opacity + b * (1 - opacity));
  const r = blend(fg.r, bg.r);
  const g = blend(fg.g, bg.g);
  const b = blend(fg.b, bg.b);
  return `#${[r, g, b].map((v) => v.toString(16).padStart(2, '0')).join('')}`;
}

function formatExcelDateTime(date: string | Date | undefined): string {
  if (!date) return '';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  const day = d.getDate().toString().padStart(2, '0');
  const month = (d.getMonth() + 1).toString().padStart(2, '0');
  const year = d.getFullYear();
  const hours = d.getHours().toString().padStart(2, '0');
  const minutes = d.getMinutes().toString().padStart(2, '0');
  return `${day}/${month}/${year} ${hours}:${minutes}`;
}

function getFieldValue(record: any, field: string): number {
  const d = record?.taskData ?? record;
  const val = Number(d?.[field]);
  return isNaN(val) ? 0 : val;
}

function formatDecimalWithSuffix(value: any, suffix?: string): any {
  if (value === null || value === undefined || value === '') return value;
  const num = Number(value);
  if (isNaN(num)) return value;
  const formatted = num.toFixed(2);
  return suffix ? `${formatted} ${suffix}` : formatted;
}

function appendSuffix(value: any, suffix: string): any {
  if (value === null || value === undefined || value === '') return value;
  return `${value} ${suffix}`;
}

export interface ExcelExportLevelOptions {
  includeAsset: boolean;
  includeOrder: boolean;
  includeOperation: boolean;
  groupByDate?: boolean;
  showEstHoursSum?: boolean;
}

export function buildGanttTreeExportRows(
  rawOrders: any[],
  options: ExcelExportLevelOptions
): any[] {
  const { includeAsset, includeOrder, includeOperation, groupByDate = false, showEstHoursSum = false } = options;

  const baseRows: any[] = [];
  const orders = (rawOrders || []).filter((o: any) => o?.order_code != null);

  const pushOrderRow = (order: any) => {
    const { subtasks: _s, childRecords: _c, ...orderForExport } = order;
    const operations = order.subtasks ?? order.childRecords ?? [];
    const orderRequired = operations.reduce((sum: number, op: any) => sum + getFieldValue(op, 'required'), 0);
    const orderDuration = operations.reduce((sum: number, op: any) => sum + getFieldValue(op, 'Duration'), 0);
    const orderWork = operations.reduce((sum: number, op: any) => sum + getFieldValue(op, 'Work'), 0);

    baseRows.push({
      ...orderForExport,
      rowType: 'order',
      orderCode: orderForExport.orderCode ?? orderForExport.order_code,
      _rawStartDate: order.StartDate,
      StartDate: formatExcelDateTime(order.StartDate),
      EndDate: formatExcelDateTime(order.EndDate),
      required: formatDecimalWithSuffix(orderRequired),
      Duration: appendSuffix(orderDuration, 'hours'),
      Work: formatDecimalWithSuffix(orderWork, 'hours'),
      _estHoursRaw: orderWork,
    });
  };

  const pushOperationRows = (order: any) => {
    const operations = order.subtasks ?? order.childRecords ?? [];
    operations.forEach((op: any) => {
      const { subtasks: _os, childRecords: _oc, ...opForExport } = op;
      const startHour = op.StartDate ? new Date(op.StartDate).getHours() : NaN;
      const estHoursRaw = getFieldValue(op, 'Work');

      baseRows.push({
        ...opForExport,
        rowType: 'operation',
        orderCode: op.orderCode ?? order.order_code,
        department_code: op.department_code ?? order.department_code,
        startHour: isNaN(startHour) ? undefined : startHour,
        _rawStartDate: op.StartDate,
        StartDate: formatExcelDateTime(op.StartDate),
        EndDate: formatExcelDateTime(op.EndDate),
        required: formatDecimalWithSuffix(opForExport.required),
        Duration: appendSuffix(opForExport.Duration, 'hours'),
        Work: formatDecimalWithSuffix(opForExport.Work, 'hours'),
        _estHoursRaw: estHoursRaw,
      });
    });
  };

  if (includeAsset) {
    const groups = new Map<string, any[]>();
    orders.forEach((order: any) => {
      const key = order.asset_code ?? 'UNASSIGNED';
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key)!.push(order);
    });

    groups.forEach((groupOrders, assetCode) => {
      const allOps = groupOrders.flatMap((o: any) => o.subtasks ?? o.childRecords ?? []);
      const assetRequired = allOps.reduce((sum: number, op: any) => sum + getFieldValue(op, 'required'), 0);
      const assetDuration = allOps.reduce((sum: number, op: any) => sum + getFieldValue(op, 'Duration'), 0);
      const assetWork = allOps.reduce((sum: number, op: any) => sum + getFieldValue(op, 'Work'), 0);
      const assetName = groupOrders.find((o: any) => o.asset_description)?.asset_description ?? assetCode;
      const starts = groupOrders.map((o: any) => new Date(o.StartDate).getTime()).filter((n: number) => !isNaN(n));
      const ends = groupOrders.map((o: any) => new Date(o.EndDate).getTime()).filter((n: number) => !isNaN(n));
      const minStart = starts.length ? new Date(Math.min(...starts)) : undefined;

      baseRows.push({
        rowType: 'asset',
        asset_code: assetCode,
        TaskName: assetName,
        _rawStartDate: minStart,
        StartDate: minStart ? formatExcelDateTime(minStart) : '',
        EndDate: ends.length ? formatExcelDateTime(new Date(Math.max(...ends))) : '',
        required: formatDecimalWithSuffix(assetRequired),
        Duration: appendSuffix(assetDuration, 'hours'),
        Work: formatDecimalWithSuffix(assetWork, 'hours'),
        _estHoursRaw: assetWork,
      });

      groupOrders.forEach((order: any) => {
        if (includeOrder) pushOrderRow(order);
        if (includeOperation) pushOperationRows(order);
      });
    });
  } else {
    orders.forEach((order: any) => {
      if (includeOrder) pushOrderRow(order);
      if (includeOperation) pushOperationRows(order);
    });
  }

  const stripInternal = (row: any) => {
    const { _rawStartDate, _estHoursRaw, ...rest } = row;
    return rest;
  };

  if (!groupByDate) {
    const finalRows = baseRows.map(stripInternal);

    if (showEstHoursSum) {
      const opRows = baseRows.filter((r) => r.rowType === 'operation');
      const sumSource = opRows.length > 0 ? opRows : baseRows;
      const grandTotal = sumSource.reduce((sum: number, r: any) => sum + (Number(r._estHoursRaw) || 0), 0);

      finalRows.push({});
      finalRows.push({
        rowType: 'footer',
        TaskName: `TOTAL ESTIMATED HOURS: ${grandTotal.toFixed(2)}`,
      });
    }
    return finalRows;
  }

    const dateGroups = new Map<string, any[]>();
  baseRows.forEach((row) => {
    const key = row._rawStartDate ? formatDate(row._rawStartDate) : 'NO DATE';
    if (!dateGroups.has(key)) dateGroups.set(key, []);
    dateGroups.get(key)!.push(row);
  });

  const sortedKeys = Array.from(dateGroups.keys()).sort((a, b) => {
    if (a === 'NO DATE') return 1;
    if (b === 'NO DATE') return -1;
    const ta = dateGroups.get(a)![0]?._rawStartDate ? new Date(dateGroups.get(a)![0]._rawStartDate).getTime() : 0;
    const tb = dateGroups.get(b)![0]?._rawStartDate ? new Date(dateGroups.get(b)![0]._rawStartDate).getTime() : 0;
    return ta - tb;
  });

  const result: any[] = [];
  sortedKeys.forEach((key) => {
    const groupRows = dateGroups.get(key)!;
    const groupRawDate = groupRows[0]?._rawStartDate;
    const displayDate = groupRawDate ? formatDateDDMMYYYY(groupRawDate) : 'NO DATE';

    result.push({
      rowType: 'header',
      TaskName: `Group: ${displayDate}`,
    });

    groupRows.forEach((row) => result.push(stripInternal(row)));

    if (showEstHoursSum) {
      const opRowsInGroup = groupRows.filter((r) => r.rowType === 'operation');
      const sumSourceGroup = opRowsInGroup.length > 0 ? opRowsInGroup : groupRows;
      const groupTotal = sumSourceGroup.reduce((sum: number, r: any) => sum + (Number(r._estHoursRaw) || 0), 0);

      result.push({
        rowType: 'footer',
        TaskName: `TOTAL ESTIMATED HOURS FOR ${displayDate}: ${groupTotal.toFixed(2)}`,
      });
    }
    result.push({});
  });

  return result;
}

function formatDateDDMMYYYY(date: string | Date): string {
  const d = new Date(date);
  if (isNaN(d.getTime())) return 'NO DATE';
  const day = d.getDate().toString().padStart(2, '0');
  const month = (d.getMonth() + 1).toString().padStart(2, '0');
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
}

export function createExcelQueryCellInfo(priorityColorData: any[] = []) {
  const baseFontStyle = { fontName: 'Aptos', fontSize: 10, wrapText: true, hAlign: 'Left', vAlign: 'Center' };
  const BOOLEAN_FIELDS = ['isRejected', 'isDone', 'isEffected'];
  const ROW_BG = EXPORT_ROW_COLORS;
  const FOOTER_BG = applyOpacity('#22d3ee', 0.8, '#ffffff');

  return (args: any) => {
    const data = args.data;
    if (!data || Object.keys(data).length === 0) return;

    if (data.rowType === 'header') {
      args.style = { ...baseFontStyle, bold: true, backColor: '#4A4A4A', fontColor: '#FFFFFF' };
      return;
    }
    if (data.rowType === 'footer') {
      args.style = { ...baseFontStyle, bold: true, backColor: '#8CEEFF', fontColor: '#00161A' };
      return;
    }

    if (BOOLEAN_FIELDS.includes(args.column?.field)) {
      args.cellValue = data[args.column.field] === true ? 'True' : 'False';
      args.style = { ...baseFontStyle, backColor: ROW_BG[data.rowType] ?? '#FFFFFF' };
      return;
    }

      /* if (['CC', 'HC', 'ST'].includes((data.site_details_1 || '').trim()) && args.column?.  field === 'TaskName') {
    args.style = { ...baseFontStyle, backColor: '#FFFF00' };
    return;
  } */
 /*  if (data.rowType === 'operation' && data.pm_schedule_id == null && args.column?.  field === 'TaskName') {
    args.style = { ...baseFontStyle, backColor: '#C6EFCE' };
    return;
  } */

    if (args.column?.field === 'priority_code' || args.column?.field === 'priority') {
  const priorityValue = data[args.column.field];
  const match = priorityColorData.find(
    (x: any) => x.priority_code?.trim() === priorityValue?.trim()
  );
  const bg = ROW_BG[data.rowType] ?? '#FFFFFF';
  const color = match?.priority_color ? applyOpacity(match.priority_color, 0.8, bg) : bg;
  args.style = {
    ...baseFontStyle,
    backColor: color,
    fontColor: '#ffffff',
    hAlign: 'Center',
    vAlign: 'Center',
    bold: true,
  };
  return;
}
    args.style = { ...baseFontStyle, backColor: ROW_BG[data.rowType] ?? '#FFFFFF', bold: data.rowType === 'order' || data.rowType === 'asset' };

    if (data.rowType === 'operation' && typeof data.startHour === 'number' && !isNaN(data.startHour)) {
      args.style = {
        ...baseFontStyle,
        backColor: data.startHour >= 6 && data.startHour < 18 ? '#FFFFFF' : '#DBDBDB',
      };
      return;
    }

  };
}

export interface WorkOrderExcelExportOptions {
  groupByDate?: boolean;
  showEstHoursSum?: boolean;
}

const formatCurrency = (val: any): string => {
    const num = Number(val);
    if (isNaN(num)) return '';
    return `$${num.toFixed(2)}`;
};

export function buildWorkOrderExportRows(
  rawOrders: any[],
  options: WorkOrderExcelExportOptions,
  labelField: string
): any[] {
  const { groupByDate = false, showEstHoursSum = false } = options;

  const baseRows = (rawOrders || []).map((order: any) => ({
    ...order,
    rowType: 'order',
    _rawStartDate: order.scheduled_start_date,
    scheduled_start_date: formatExcelDateTime(order.scheduled_start_date),
    scheduled_end_date: formatExcelDateTime(order.scheduled_end_date),
    planned_start_date: formatExcelDateTime(order.planned_start_date),
    planned_end_date: formatExcelDateTime(order.planned_end_date),
    wo_labour_cost: formatCurrency(order.wo_labour_cost),
    wo_material_cost: formatCurrency(order.wo_material_cost),
    wo_other_cost: formatCurrency(order.wo_other_cost),
    _estHoursRaw: Number(order.duration) || 0,
}));

  const stripInternal = (row: any) => {
    const { _rawStartDate, _estHoursRaw, ...rest } = row;
    return rest;
  };

  if (!groupByDate) {
    const finalRows = baseRows.map(stripInternal);

    if (showEstHoursSum) {
      const grandTotal = baseRows.reduce((sum: number, r: any) => sum + r._estHoursRaw, 0);
      finalRows.push({});
      finalRows.push({
        rowType: 'footer',
        [labelField]: `TOTAL DURATION: ${grandTotal.toFixed(2)}`,
      });
    }
    return finalRows;
  }

  const dateGroups = new Map<string, any[]>();
  baseRows.forEach((row) => {
    const key = row._rawStartDate ? formatDate(row._rawStartDate) : 'NO DATE';
    if (!dateGroups.has(key)) dateGroups.set(key, []);
    dateGroups.get(key)!.push(row);
  });

  const sortedKeys = Array.from(dateGroups.keys()).sort((a, b) => {
    if (a === 'NO DATE') return 1;
    if (b === 'NO DATE') return -1;
    const ta = dateGroups.get(a)![0]?._rawStartDate ? new Date(dateGroups.get(a)![0]._rawStartDate).getTime() : 0;
    const tb = dateGroups.get(b)![0]?._rawStartDate ? new Date(dateGroups.get(b)![0]._rawStartDate).getTime() : 0;
    return ta - tb;
  });

  const result: any[] = [];
  sortedKeys.forEach((key) => {
    const groupRows = dateGroups.get(key)!;
    const groupRawDate = groupRows[0]?._rawStartDate;
    const displayDate = groupRawDate ? formatDateDDMMYYYY(groupRawDate) : 'NO DATE';

    result.push({ rowType: 'header', [labelField]: `Group: ${displayDate}` });
    groupRows.forEach((row) => result.push(stripInternal(row)));

    if (showEstHoursSum) {
      const groupTotal = groupRows.reduce((sum: number, r: any) => sum + r._estHoursRaw, 0);
      result.push({
        rowType: 'footer',
        [labelField]: `TOTAL DURATION FOR ${displayDate}: ${groupTotal.toFixed(2)}`,});
    }
    result.push({});
  });

  return result;
}


export interface OperationExcelExportOptions {
  groupByDate?: boolean;
  showEstHoursSum?: boolean;
}

export function buildOperationExportRows(
  rawOperations: any[],
  options: OperationExcelExportOptions,
  labelField: string
): any[] {
  const { groupByDate = false, showEstHoursSum = false } = options;

  const baseRows = (rawOperations || []).map((op: any) => {
    const startHour = op.scheduled_start_date
      ? new Date(op.scheduled_start_date).getHours()
      : undefined;
    return {
      ...op,
      rowType: 'operation',
      startHour,
      _rawStartDate: op.scheduled_start_date,
      scheduled_start_date: formatExcelDateTime(op.scheduled_start_date),
      scheduled_end_date: formatExcelDateTime(op.scheduled_end_date),
      plannedStartDate: formatExcelDateTime(op.plannedStartDate),
      planned_end_date: formatExcelDateTime(op.planned_end_date),
      _estHoursRaw: Number(op.estHours) || 0,
    };
  });

  const stripInternal = (row: any) => {
    const { _rawStartDate, _estHoursRaw, ...rest } = row;
    return rest;
  };

  if (!groupByDate) {
    const finalRows = baseRows.map(stripInternal);

    if (showEstHoursSum) {
      const grandTotal = baseRows.reduce((sum: number, r: any) => sum + r._estHoursRaw, 0);
      finalRows.push({});
      finalRows.push({
        rowType: 'footer',
        [labelField]: `TOTAL EST. HOURS: ${grandTotal.toFixed(2)}`,
      });
    }
    return finalRows;
  }

  const dateGroups = new Map<string, any[]>();
  baseRows.forEach((row) => {
    const key = row._rawStartDate ? formatDate(row._rawStartDate) : 'NO DATE';
    if (!dateGroups.has(key)) dateGroups.set(key, []);
    dateGroups.get(key)!.push(row);
  });

  const sortedKeys = Array.from(dateGroups.keys()).sort((a, b) => {
    if (a === 'NO DATE') return 1;
    if (b === 'NO DATE') return -1;
    const ta = dateGroups.get(a)![0]?._rawStartDate
      ? new Date(dateGroups.get(a)![0]._rawStartDate).getTime()
      : 0;
    const tb = dateGroups.get(b)![0]?._rawStartDate
      ? new Date(dateGroups.get(b)![0]._rawStartDate).getTime()
      : 0;
    return ta - tb;
  });

  const result: any[] = [];
  sortedKeys.forEach((key) => {
    const groupRows = dateGroups.get(key)!;
    const groupRawDate = groupRows[0]?._rawStartDate;
    const displayDate = groupRawDate ? formatDateDDMMYYYY(groupRawDate) : 'NO DATE';

    result.push({ rowType: 'header', [labelField]: `Group: ${displayDate}` });
    groupRows.forEach((row) => result.push(stripInternal(row)));

    if (showEstHoursSum) {
      const groupTotal = groupRows.reduce((sum: number, r: any) => sum + r._estHoursRaw, 0);
      result.push({
        rowType: 'footer',
        [labelField]: `TOTAL EST. HOURS FOR ${displayDate}: ${groupTotal.toFixed(2)}`,
      });
    }
    result.push({});
  });

  return result;
}